<taku-form-header
  displayMode="full"
  *ngIf="_pageTitle || _pageIconStyleClass"
  (backClicked)="goBack()"
  [toolbarTitle]="_pageTitle"
  [iconStyleClass]="_pageIconStyleClass"
  [showActionBtns]="false"
  [showBackBtn]="!_disableBackLink"
></taku-form-header>

<div class="paneltitle-right">
  <ng-content select="*.panel-toolbar"></ng-content>
</div>

<taku-form-list
  [ngClass]="{ pullDown: _pageTitle || _pageIconStyleClass }"
  [_model]="_model"
  [_detailMode]="_detailMode"
  [_filter]="_filter"
  [_cols]="_cols"
  [_title]="_formlistTitle"
  [_settingsCol]="_settingsCol"
  [_defaultRowValues]="_defaultRowValues"
  [_extraQueryParams]="_extraQueryParams"
  (_onNewRowSaved)="onNewStoreCreated($event)"
></taku-form-list>
